export const ON_EVENTS_MOUNT = '@MyEvents/ON_MY_EVENTS_MOUNT';
export const ON_EVENTS_MOUNT_ERROR = '@MyEvents/ON_MY_EVENTS_MOUNT_ERROR';
export const ON_MY_EVENTS_STATUS_FILTER_CHANGE = 'ON_MY_EVENTS_STATUS_FILTER_CHANGE';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';
export const ON_SHOW_LOADING_STATE = 'ON_SHOW_LOADING_STATE';

export const onMyEventsMount = () => ({ type: ON_EVENTS_MOUNT });

// Actions
export const onMyEventsStatusFilterChange = (value) => ({
  type: ON_MY_EVENTS_STATUS_FILTER_CHANGE,
  payload: value
});

export const clearFlashMessage = () => ({
  type: CLEAR_FLASH_MESSAGE
});

export const showFlashMessage = (level, message) => ({
  type: ADD_FLASH_MESSAGE,
  payload: {
    level,
    message
  }
});

export const onUpdateSearchText = (value) => ({
  type: UPDATE_SEARCH_TEXT,
  payload: value
});

export const onShowLoadingState = () => ({
  type: ON_SHOW_LOADING_STATE
});



// WEBPACK FOOTER //
// ./src/modules/my-events/actions.js